import React, { useEffect, useState } from 'react'
import { bg_splash, circle_progress, logo } from '../../Images'
import { back } from '../../Images/Icons'
import css from './SplashScreen.module.scss'
const SplashScreen = ({ onStarted }) => {
    const [state, setNewState] = useState({ startAnimate: false });

    const setState = data => {
        setNewState(prevState => ({ ...prevState, ...data }));
    }

    useEffect(() => {
        setTimeout(() => {
            setState({ startAnimate: true });
        }, 1000);
    }, []);

    const { startAnimate } = state;

    return (
        <div className={css.wrap}>
            <div className={css.top_section} style={{  }}>
                <div className={startAnimate ? 'splash-screen-center' : 'splash-screen-top'} style={{
                    backgroundImage: `url(${bg_splash})`, backgroundSize: 'cover'
                }}>
                    <img src={logo} alt="" />
                </div>
            </div>
            <div className={css.circle}>
                <img src={circle_progress} alt="" />
            </div>
            <div style={{ flex: 1 }}>
                <div className={css.bottom_section} >
                    <div className={startAnimate ? 'splash-screen-bottom-center' : 'splash-screen-bottom'}>
                        <div className={css.font_big}>
                            Powering Indonesia's solar powered future for a cleaner and greener tomorrow
                        </div>
                        <div className={css.font_small}>
                            Real time plant monitoring.
                        </div>
                        <div className={css.wrap_button}>
                            <div onClick={onStarted} className={css.button_style}>
                                Get Started
                                <img src={back} className={css.arrow} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SplashScreen